import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ExportIcon16pxSvg from '../assets/images/icons/ExportIcon16pxSvg';
import UploadIcon16pxSvg from '../assets/images/icons/UploadIcon16pxSvg';

const DropZoneInput = (props) => {
  const { t } = useTranslation();
  const { className = '' } = props;

  const [dragging, setDragging] = useState(false);

  const handleDragOver = (e) => { e.preventDefault(); setDragging(true); };
  const handleDragEnter = (e) => { e.preventDefault(); setDragging(true); };
  const handleDragLeave = (e) => { e.preventDefault(); setDragging(false); };
  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) props.handleDropChange?.(props.name, file);
  };

  const fileInputRef = useRef(null);
  const handleButtonClick = () => fileInputRef.current?.click();

  const handleFileInputChange = (e) => {
    props.handleInputChange?.(e);      // giữ hành vi cũ
    // reset value để lần sau chọn cùng file vẫn fire onChange
    if (e.target) {
      e.target.value = "";
    }
  };

  // Hỗ trợ keyboard (Enter/Space) để mở chọn file
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleButtonClick();
    }
  };

  // Tên hiển thị gọn, tránh tràn
  const displayName = props.file?.name || '';

  return (
    <div
      className={`file-dropzone w-full ${dragging ? 'dragging' : ''} ${className}`}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div
        role="button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
        aria-label={t('common.choose-file') || 'Choose file'}
        className={`w-full px-4 border-[2px] border-dashed rounded-lg cursor-pointer
                    flex items-center justify-center text-center
                    ${dragging ? 'border-blue-400 bg-blue-50' : 'border-gray-300'}
                   `}
        style={{
          minHeight: 32,         
          paddingTop: 12,
          paddingBottom: 12,
        }}
        onClick={handleButtonClick}
      >
        {props.file ? (
          <p
            className="text-base font-medium max-w-full truncate"
            title={displayName}
            style={{ maxWidth: '95%' }}  // tránh tràn
          >
            {displayName}
          </p>
        ) : (
          <p className="text-base flex items-center gap-1 text-[#6B7280]">
            <UploadIcon16pxSvg /> {' '}{t('common.drop-your-file-here-or')}{' '}
            <span className="text-[#3B82F6] font-semibold">{t('common.browse')}</span>
          </p>
        )}
      </div>

      <input
        type="file"
        id={props.id}
        name={props.name}
        onChange={handleFileInputChange}
        ref={fileInputRef}
        className="hidden"
        // accept={props.accept} // nếu muốn truyền mime types từ ngoài
      />
    </div>
  );
};

export default DropZoneInput;
